import { IconProps } from "./types";

const AppleLogoIcon = (props: IconProps) => (
  <svg
    width={props.width || 28}
    height={props.height || 28}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.854 25.563c-1.329 1.327-2.78 1.117-4.177.489-1.479-.643-2.835-.67-4.395 0-1.953.866-2.984.614-4.15-.49C1.513 18.539 2.49 7.84 10.004 7.449c1.83.098 3.106 1.034 4.177 1.118 1.6-.336 3.133-1.3 4.842-1.174 2.048.168 3.595 1.006 4.612 2.514-4.232 2.612-3.228 8.352.65 9.958-.772 2.095-1.776 4.177-3.444 5.713l.013-.014ZM14.046 7.364c-.204-3.114 2.251-5.684 5.072-5.935.394 3.603-3.174 6.285-5.072 5.935Z"
    />
  </svg>
);

export default AppleLogoIcon;
